'use strict';

document.addEventListener('DOMContentLoaded', () => {

    document.getElementById('submit-email-btn').addEventListener('click', handleMailSubmit);

    function displayMessage(data) {
        $.spinner().stop();
        var status = data.success ? 'alert-success' : 'alert-danger';

        if ($('.add-to-wishlist-messages').length === 0) {
            $('body').append('<div class="add-to-wishlist-messages"></div>');
        }

        $('.add-to-wishlist-messages').append(
            $('<div>', {
                class: 'alert text-center add-to-wishlist-alert ' + status,
                text: data.msg // Safely sets the text content, escaping any HTML
            })
        );

        setTimeout(function () {
            $('.add-to-wishlist-messages').remove();
        }, 5000);
    }

    function getInputMail() {
        let mailInput = document.getElementById('wgaca-updates-sign-up-mail').value.trim(); //fetching user input
        document.getElementById('subscription-status').style.color = "#C61B1B";
        document.getElementById('wgaca-updates-sign-up-mail').style.borderColor = "#C61B1B";
        if (mailInput) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;  // Validate email format with basic email regex
            if (!emailPattern.test(mailInput)) {
                document.getElementById('subscription-status').innerText = window.signupMessages.enterValidEmail;
            } else {
                return mailInput;
            }
        } else {
            document.getElementById('subscription-status').innerText = window.signupMessages.enterEmailSubmit;
        }
        document.getElementById('wgaca-updates-sign-up-mail').focus();
        return;
    }
    async function handleMailSubmit() {
        const inputMail = getInputMail();   //taking user email
        if (inputMail) {
            var form = new FormData();
            form.set("emailId", inputMail);

            try {
                const response = await fetch(window.signupUrls.subscribeUrl, {
                    method: 'POST',
                    body: form
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${('msg' in response) ? response.msg : ''}`);
                }

                const data = await response.json();
                displayMessage(data);
                if (data.success) {
                    if (Array.isArray(data.__gtmEvents)) {  
                        window.dataLayer = window.dataLayer || [];
                        data.__gtmEvents.forEach(event => {
                        window.dataLayer.push(event);
                    });
                    }
                try {
                    sessionStorage.setItem('subscribedEmail', inputMail);
                } catch (err) {
                    console.warn(' Could not save to sessionStorage:', err);
                }
                    document.getElementById('subscription-status').innerText = '';
                    document.getElementById('wgaca-updates-sign-up-mail').value = '';
                    document.getElementById('wgaca-updates-sign-up-mail').style.borderColor = "initial";
                }
            } catch (error) {
                // console.error("Error during mail submission:", error);
                displayMessage({ msg: window.signupMessages.unexpectedError, success: false });
            }
        }
    };

    async function sendEmailToSFMC(email) {
        var form = new FormData();
        form.set("emailId", email);
        try {
            const response = await fetch(window.signupUrls.subscribeUrl, {
                method: 'POST',
                body: form
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${('msg' in response) ? response.msg : ''}`);
            }

            const data = await response.json();
        } catch (error) {
            console.error("Error during mail submission:", error);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.getElementById('wgaca-updates-sign-up-mail').addEventListener('blur', () => {
            document.getElementById('subscription-status').innerText = '';
            document.getElementById('wgaca-updates-sign-up-mail').style.borderColor = "initial";
        });

        const footerLinks = document.getElementById('footercontent').querySelectorAll('a');
        footerLinks.forEach(link => {
            link.addEventListener('click', () => {
                sessionStorage.setItem('activeNavLink', '');
            });
        });
    });
});
document.addEventListener("wunderkindSubscribeEmail", function (event) {
    if (event.detail && event.detail.email) {
        let email = event.detail.email;
        sendEmailToSFMC(email);
    }
});